import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowCenter"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3L21 3V14H19V5L5 5L5 19H14V21H3L3 3ZM9 9L16 9V11L12.4142 11L19.4142 18L18 19.4142L11 12.4142V16H9V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowCenter;
